import axios from 'axios';

export const uploadFile = file => {
  const data = new FormData();
  data.append('file', file);

  const config = { headers: { 'content-type': 'multipart/form-data' } };
  return axios.post(`/config/image_upload/`, data, config);
};
